import React from "react";
import { Box, ButtonProps, Link, SxProps } from "@mui/material";
import {
  languageMap,
  LanguageSelector as SharedLanguageSelector,
  useConfig,
} from "@thekilroygroup/shared-ui";
import { useDispatch, useSelector } from "react-redux";
import { languageSelector, setLanguage } from "../../redux/language";
import { IAppConfigObject } from "../../appConfig.interfaces";

interface IProps {
  color?: "primary" | "secondary" | "black" | "white";
  sxProps?: SxProps;
  buttonProps?: ButtonProps;
}

export const LanguageSelector = (props: IProps) => {
  const dispatch = useDispatch();
  const { language } = useSelector(languageSelector);
  const {
    appConfig: { PRIMARY_LANGUAGE, SECONDARY_LANGUAGE },
  } = useConfig<IAppConfigObject>();

  const handleLanguageChange = (lang: string) => {
    dispatch(setLanguage(lang));
  };

  const links = [PRIMARY_LANGUAGE, SECONDARY_LANGUAGE].map((lang) => (
    <Link key={lang} onClick={() => handleLanguageChange(lang)}>
      {languageMap[lang as keyof typeof languageMap]}
    </Link>
  ));

  const isEnglish =
    PRIMARY_LANGUAGE.includes("en") && SECONDARY_LANGUAGE.includes("en");

  return (
    <Box>
      {!isEnglish && (
        <SharedLanguageSelector
          currentLanguage={language || PRIMARY_LANGUAGE}
          links={links}
          {...props}
        />
      )}
    </Box>
  );
};
